; (function () {
  'use strict'

  angular
    .module('deskfy.arts')
    .directive('artsListFilter', artsListFilter)

  function artsListFilter () {
    return {
      restrict: 'E',
      templateUrl: '/arts/directives/arts-list-filter/arts-list-filter-directive.html?$$REVISION$$'
    }
  }
})()
